module.exports = __webpack_public_path__ + "static/img/home_month.2b1ccac.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_icons/home_month.jpeg
// module id = KRYh
// module chunks = 4